module.exports = __webpack_public_path__ + "static/assets/770c726dfd709e493bde06c9fd6b9f31.png";